import * as React from "react";
import Component from "../../AbstractComponent";
import { Property } from "../../../Entity/Entities/Property/Property";
import { Unit } from "../../../Entity/Entities/Unit/Unit";
import { Charge } from "../../../Entity/Entities/Charge/Charge";
import { Event } from "../../../Entity/Entities/Event/Event";
import { Contract } from "../../../Entity/Entities/Contract/Contract";
import { PromptDialog } from "./PromptDialog";
import { DatePickerComponent } from "../DatePicker/DatePickerComponent";
import Constants from "../../../Action/Constants";
import TextField from "../Material/TextField";
import { PageTransition } from "../Spinner/PageTransition";
import * as uuidV4 from "uuid/v4";
// import { ConversationInterface } from "../../../Entity/Entities/Conversation/ConversationInterface";
import Time from "../../../Time/Time";

export class NewNotificationDialog extends Component {
  protected timer;
  public contactLookup;

  public state = {
    notificationDate: new Date(),
    notificationText: '',
    isOpen: false,
    entity: this.props.entity,
    isSaving: false,
    amazonFolderName: uuidV4(),
    emptyText: false,
  };

  constructor(public props) {
    super(props);
    this.contactLookup = React.createRef();
  }

  public componentWillReceiveProps(nextProps) {

    if (nextProps.isOpen !== this.state.isOpen) {
      this.setState({
        isOpen: nextProps.isOpen,
      });
    }

    if (nextProps.entity !== this.state.entity) {
      this.setState({
        entity: nextProps.entity
      })
    }
  }

  public componentWillUnmount() {
    this.setState({
      notificationDate: null,
      notificationText: '',
      isOpen: false,
      entity: null,
      isSaving: false,
      emptyText: false,
    })
  }


  public clearState = () => {
    this.setState({
      notificationDate: null,
      notificationText: '',
      isOpen: false,
      entity: null,
      isSaving: false,
      emptyText: false,
    })
  }

  public save = () => {
    if (this.state.notificationText.length === 0) {
      this.setState({
        emptyText: true,
      })
    } else {
      this.props.dispatch({
        type: Constants.GLOBAL_EVENT_CREATE_CLEAR
      });

      const notification: any = {
        content: {
          name: this.state.notificationText, // TODO decide in which place to save the notif message
          details: this.state.notificationText,
        },
        remindDate: Time.formatOrNull(this.state.notificationDate),
        eventTypeId: 3,
      }

      if (this.props.entity instanceof Property) {
        notification.propertyId = this.props.entity?.id;
      }

      if (this.props.entity instanceof Unit) {
        notification.unitId = this.props.entity?.id;
      }

      if (this.props.entity instanceof Charge) {
        notification.chargeId = this.props.entity?.id;
      }

      if (this.props.entity instanceof Event) {
        notification.refersToEventId = this.props.entity?.id;
      }
      if (this.props.entity instanceof Contract) {
        notification.contractId = this.props.entity?.id;
      }

      this.saving(() => {
        this.props.dispatch({
          type: Constants.GLOBAL_EVENT_CREATE_START,
          payload: {
            ...notification
          },
          onSuccess: () => {
            this.setState({
              isSaving: false,
            }, this.props.closeDialog());
          },
          onError: (err) => {
            this.setState({
              isSaving: false,
              error: err
            })
          }
        });
      });
    }

  }

  public renderContent = () => {
    return (
      <div style={{ width: "420px" }}>
        <div>
          <DatePickerComponent
            {...this.props}
            id="remind-date"
            name="remind-date"
            className="scroll-to-remind-date"
            label={this.trans("date")}
            initialDate={this.state.notificationDate}
            minDate={new Date()}
            onChange={(date) => this.setState({ notificationDate: date })}
            clearButton={false}
            clearable={false}
            error={this.state.notificationDate === null}
          />

          <TextField
            type="text"
            value={this.state.notificationText}
            onChange={(e) => this.setState({ notificationText: e.target.value })}
            autoFocus={true}
            style={{ width: "100%" }}
            className="form-size scroll-to-notification-text"
            label={this.trans("dialog-new-notification-text")}
            error={this.state.emptyText}
            required={true}
          />
        </div>
      </div>
    );
  }

  public render() {
    return (
      <div>
        <PromptDialog
          {...this.props}
          openLeavePrompt={this.state.isOpen}
          title={this.trans("menuitem-create-notification")}
          subtitle={this.state.entity?.displayName || ""}
          content={this.renderContent()}
          positiveButtonLabel={this.trans("button-create")}
          negativeButtonLabel={this.trans("dialog-button/cancel")}
          onSave={() => this.save()}
          disablePositiveButton={this.state.notificationDate === null || this.state.notificationText?.trim().length === 0}
          onDiscard={() => {
            this.clearState();
            this.props.closeDialog();
          }
          }
        />

        <PageTransition isSaving={this.state.isSaving} />
      </div>
    );
  }
}
